"use client";

import React from "react";
import { useLoading } from "@context/LoadingContext";
import GlobalLoader from "@components/atoms/GlobalLoader/GlobalLoader";

interface GlobalLoaderOverlayProps {
  variant?: "spinner" | "dots" | "pulse" | "lottie";
  size?: "small" | "medium" | "large";
}

const GlobalLoaderOverlay: React.FC<GlobalLoaderOverlayProps> = ({
  variant = "lottie",
  size = "large",
}) => {
  const { isLoading, loadingText } = useLoading();

  return (
    <GlobalLoader
      isLoading={isLoading}
      overlay={true}
      text={loadingText}
      size={size}
      variant={variant}
    />
  );
};

export default GlobalLoaderOverlay; 